import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import dayjs, { Dayjs } from "dayjs"
import { IInterviewer } from "../../../../model/create/CreateInterwiewer"

const IInterwieverState: IInterviewer = {
  id: null,
  interviewer: null,
  permanentLink: null,
  temporaryLink: null,
  tgLink: null,
}
const InterwieverSlice = createSlice({
  name: "Interwiever",
  initialState: IInterwieverState,
  reducers: {
    setInterwieverState: (state, action: PayloadAction<IInterviewer>) => {
      state.id = action.payload.id
      state.interviewer = action.payload.interviewer
      state.permanentLink = action.payload.permanentLink
      state.temporaryLink = action.payload.temporaryLink
      state.tgLink = action.payload.tgLink
    },
  },
})

export const interwieverReducer = InterwieverSlice.reducer

export const { setInterwieverState } = InterwieverSlice.actions
